import { render } from "./UserUpdatePhoto.vue?vue&type=template&id=0902bdf2&scoped=true"
import script from "./UserUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./UserUpdatePhoto.vue?vue&type=script&lang=js"

import "./UserUpdatePhoto.vue?vue&type=style&index=0&id=0902bdf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0902bdf2"]])

export default __exports__